export const TEMPORARY_ACCOUNT_NUMBER_LENGTH = 36;
